import { CircleCheck, MessageSquare, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const cards = [{
  title: "Cifrado de Extremo a Extremo",
  description: "Protege todas las llamadas VoIP con algoritmos avanzados para garantizar la privacidad total.",
  icon: ShieldCheck
}, {
  title: "Autenticación y Control",
  description: "Validación rigurosa de dispositivos y restricción estricta de tráfico no autorizado en su red.",
  icon: CircleCheck
}, {
  title: "Prevención de Amenazas",
  description: "Detección y bloqueo proactivo de ataques DDoS, intentos de fraude y software malicioso.",
  icon: MessageSquare
}];
export default function CaracterSticasDeSeguridad() {
  return <section data-section-id="259970" id="características-de-seguridad" className="bg-background text-foreground">
      <div className="bg-background py-24">
        <div className="container mx-auto px-4 md:px-6">
          <div className="mb-12 text-center">
            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
              Características de Seguridad
            </h2>
          </div>
          <div className="grid gap-6 md:grid-cols-3">
            {cards.map((card, i) => {
            const Icon = card.icon;
            return <Card key={i} data-index={i} className="border-border border-[1px] rounded-md shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
                  <CardHeader className="justify-items-center pb-4 text-center">
                    <div className="mb-2 rounded-full bg-primary p-4">
                      <Icon className="size-8 text-primary-foreground" />
                    </div>
                    <CardTitle className="font-default text-[32px] font-bold text-card-foreground leading-tight">
                      {card.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center">
                    <p className="font-sans text-base text-muted-foreground">
                      {card.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}